import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import AddToCart from './AddToCart'
const Pricing = (props) => {
   const { basketState, formState, setCurrentStepIndex, listData } = props
   const [price, setPrice] = useState(0.00)

   useEffect(() => {
      if (basketState) {
         const total = Object.values(basketState).reduce((previous, currrent) => {
            const currentCost = currrent.price?.value ? currrent.price.value : 0
            return previous + currentCost
         }, 0)
         setPrice(total.toFixed(2))
      }
   }, [basketState])

   return (
      <Row>
         <Col className='d-flex  justify-content-lg-center py-1'>

            <h4> &pound;{price} </h4>

            <div className='ms-auto d-lg-none'>
               <AddToCart
                  setCurrentStepIndex={setCurrentStepIndex}
                  basketState={basketState}
                  listData={listData}
                  formState={formState}
               />
            </div>

         </Col>
      </Row >
   )
}
export default Pricing